/**
 * 尺码指南计算器 JavaScript - 男士版本
 * 提供男士尺码计算功能
 */

// 全局函数，用于打开尺码计算器（提前定义以确保在onclick调用时可用）
if (typeof window.openBraSizeCalculator === 'undefined') {
  window.openBraSizeCalculator = function(type = 'women') {
    const modalId = type === 'men' ? 'bra-size-calculator-men' : 
                     type === 'kids' ? 'bra-size-calculator-kids' : 
                     'bra-size-calculator-women';
    
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
      // 设置 main 元素的 z-index，防止被 header 覆盖
      const mainElement = document.querySelector('.main');
      if (mainElement) {
        mainElement.style.zIndex = '501';
      }
    }
  };
}

// 男士尺码计算器类
class MenSizeCalculator {
  constructor() {
    this.modal = null;
    this.type = 'men';
    this.recommendedSize = null;
    this.recommendedSizeUS = null; // 保存US尺码
    this.mouseDownOnContent = false; // 记录鼠标是否在弹框内容区域按下
  }

  init() {
    this.bindEvents();
    this.generateSizeTable();
    // 初始化时更新输入框 placeholder
    this.updateLoungeInputPlaceholder();
    this.updateTruckInputPlaceholder();
  }

  bindEvents() {
    if (!this.modal) return;
    
    // 关闭模态框
    this.modal.querySelectorAll('[data-close-modal]').forEach(trigger => {
      trigger.addEventListener('click', () => this.closeModal());
    });

    // Tab 切换
    this.modal.querySelectorAll('.bra-size-calculator__tab').forEach(tab => {
      tab.addEventListener('click', (e) => {
        const tabName = e.target.dataset.tab;
        this.switchTab(tabName);
      });
    });

    // Lounge & Layers tab 相关事件
    // 分类选择器（Lounge & Layers）
    const categorySelectLounge = this.modal.querySelector('#category-type-men-lounge');
    if (categorySelectLounge) {
      categorySelectLounge.addEventListener('change', () => {
        this.updateLoungeInputPlaceholder();
      });
      // 初始化时更新一次
      this.updateLoungeInputPlaceholder();
    }

    // Size Type 选择器（Lounge & Layers）
    const sizeTypeSelectLounge = this.modal.querySelector('#size-type-men-lounge');
    if (sizeTypeSelectLounge) {
      const initialSizeType = sizeTypeSelectLounge.value || 'us';
      if (initialSizeType) {
        const event = new Event('change');
        sizeTypeSelectLounge.value = initialSizeType;
        sizeTypeSelectLounge.dispatchEvent(event);
      }
      
      // 当切换US/EU时，如果已有计算结果，更新显示
      sizeTypeSelectLounge.addEventListener('change', () => {
        const resultElement = document.getElementById('recommended-size-men-lounge');
        const resultContainer = document.getElementById('size-result-men-lounge');
        if (resultElement && resultContainer && resultContainer.style.display !== 'none' && this.recommendedSizeUS) {
          // 根据US尺码和当前选择的类型显示对应的尺码
          const sizeType = sizeTypeSelectLounge.value;
          const sizeMap = {
            'S': { us: 'S', eu: 'M' },
            'M': { us: 'M', eu: 'L' },
            'L': { us: 'L', eu: 'XL' },
            'XL': { us: 'XL', eu: 'XXL' },
            'XXL': { us: 'XXL', eu: 'XXXL' },
            'XXXL': { us: 'XXXL', eu: '4XL' }
          };
          
          const sizeInfo = sizeMap[this.recommendedSizeUS];
          if (sizeInfo) {
            const displaySize = sizeType === 'eu' ? sizeInfo.eu : sizeInfo.us;
            resultElement.textContent = displaySize;
            this.recommendedSize = displaySize;
          }
        }
      });
    }

    // 单位切换按钮（Lounge & Layers）
    this.modal.querySelectorAll('[data-unit][data-type="men-lounge"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const newUnit = e.target.dataset.unit;
        this.handleUnitToggle(newUnit, 'men-lounge');
        // 切换单位时重新生成 Lounge & Layers 表格
        const loungeTableBody = this.modal.querySelector('#lounge-size-table-body-men');
        if (loungeTableBody) {
          this.generateLoungeSizeTable(loungeTableBody);
        }
        // 更新输入框placeholder
        this.updateLoungeInputPlaceholder();
      });
    });

    // 计算 Lounge & Layers 尺码
    const calculateLoungeBtn = this.modal.querySelector('[data-calculate-lounge-size-men]');
    if (calculateLoungeBtn) {
      calculateLoungeBtn.addEventListener('click', () => {
        this.calculateLoungeSizeMen();
      });
    }

    // Lounge & Layers tab 输入框回车键触发查询
    const loungeInput = document.getElementById('measurement-men-lounge');
    if (loungeInput) {
      loungeInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.calculateLoungeSizeMen();
        }
      });
    }


    // Truck & Boxer tab 相关事件
    // 分类选择器（Truck & Boxer）
    const categorySelectTruck = this.modal.querySelector('#category-type-men-truck');
    if (categorySelectTruck) {
      categorySelectTruck.addEventListener('change', () => {
        this.updateTruckInputPlaceholder();
      });
      // 初始化时更新一次
      this.updateTruckInputPlaceholder();
    }

    // Size Type 选择器（Truck & Boxer）
    const sizeTypeSelectTruck = this.modal.querySelector('#size-type-men-truck');
    if (sizeTypeSelectTruck) {
      const initialSizeType = sizeTypeSelectTruck.value || 'us';
      if (initialSizeType) {
        const event = new Event('change');
        sizeTypeSelectTruck.value = initialSizeType;
        sizeTypeSelectTruck.dispatchEvent(event);
      }
      
      // 当切换US/EU时，如果已有计算结果，更新显示
      sizeTypeSelectTruck.addEventListener('change', () => {
        const resultElement = document.getElementById('recommended-size-men-truck');
        const resultContainer = document.getElementById('size-result-men-truck');
        if (resultElement && resultContainer && resultContainer.style.display !== 'none' && this.recommendedSizeUS) {
          // 根据US尺码和当前选择的类型显示对应的尺码
          const sizeType = sizeTypeSelectTruck.value;
          const sizeMap = {
            'S': { us: 'S', eu: 'M' },
            'M': { us: 'M', eu: 'L' },
            'L': { us: 'L', eu: 'XL' },
            'XL': { us: 'XL', eu: 'XXL' },
            'XXL': { us: 'XXL', eu: 'XXXL' },
            'XXXL': { us: 'XXXL', eu: '4XL' }
          };
          
          const sizeInfo = sizeMap[this.recommendedSizeUS];
          if (sizeInfo) {
            const displaySize = sizeType === 'eu' ? sizeInfo.eu : sizeInfo.us;
            resultElement.textContent = displaySize;
            this.recommendedSize = displaySize;
          }
        }
      });
    }

    // 单位切换按钮（Truck & Boxer）
    this.modal.querySelectorAll('[data-unit][data-type="men-truck"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const newUnit = e.target.dataset.unit;
        this.handleUnitToggle(newUnit, 'men-truck');
        // 切换单位时重新生成 Truck & Boxer 表格
        const truckTableBody = this.modal.querySelector('#truck-size-table-body-men');
        if (truckTableBody) {
          this.generateTruckSizeTable(truckTableBody);
        }
        // 更新输入框placeholder
        this.updateTruckInputPlaceholder();
      });
    });

    // 计算 Truck & Boxer 尺码
    const calculateTruckBtn = this.modal.querySelector('[data-calculate-truck-size-men]');
    if (calculateTruckBtn) {
      calculateTruckBtn.addEventListener('click', () => {
        this.calculateTruckSizeMen();
      });
    }

    // Truck & Boxer tab 输入框回车键触发查询
    const truckInput = document.getElementById('measurement-men-truck');
    if (truckInput) {
      truckInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.calculateTruckSizeMen();
        }
      });
    }


    // ESC键关闭
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.style.display !== 'none') {
        this.closeModal();
      }
    });

    // 记录鼠标是否在弹框内容区域按下
    this.modal.addEventListener('mousedown', (e) => {
      // 如果鼠标在弹框内容区域（modal 的子元素）按下，设置标志
      this.mouseDownOnContent = e.target !== this.modal;
    });

    // 点击外部关闭（只有在遮罩层上点击且没有从内容区域拖拽过来才关闭）
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal && !this.mouseDownOnContent) {
        this.closeModal();
      }
      // 重置标志
      this.mouseDownOnContent = false;
    });
  }

  switchTab(tabName) {
    if (!this.modal) return;
    
    // 更新标签页状态
    this.modal.querySelectorAll('.bra-size-calculator__tab').forEach(tab => {
      tab.classList.remove('active');
    });
    const activeTab = this.modal.querySelector(`[data-tab="${tabName}"]`);
    if (activeTab) activeTab.classList.add('active');

    // 更新面板状态
    this.modal.querySelectorAll('.bra-size-calculator__panel').forEach(panel => {
      panel.classList.remove('active');
      panel.style.display = 'none';
    });
    const activePanel = this.modal.querySelector(`[data-panel="${tabName}"]`);
    if (activePanel) {
      activePanel.classList.add('active');
      activePanel.style.display = 'block';
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
      // 恢复 main 元素的 z-index
      const mainElement = document.querySelector('.main');
      if (mainElement) {
        mainElement.style.zIndex = '';
      }
    }
  }

  calculateLoungeSizeMen() {
    const input = document.getElementById('measurement-men-lounge');
    if (!input) return;
    
    let measurement = parseFloat(input.value);
    
    if (!measurement || isNaN(measurement)) {
      alert('Please enter a measurement');
      return;
    }

    // 获取当前单位、分类和尺码类型
    const currentUnit = this.getCurrentUnit('men-lounge');
    const categorySelect = document.getElementById('category-type-men-lounge');
    const category = categorySelect ? categorySelect.value : 'height';
    const sizeTypeSelect = document.getElementById('size-type-men-lounge');
    const sizeType = sizeTypeSelect ? sizeTypeSelect.value : 'us';
    
    // 获取表格数据（基于当前单位）
    let sizeData;
    if (currentUnit === 'in') {
      sizeData = [
        { sizeUS: 'S', sizeEU: 'M', heightRange: [65, 67], bustRange: [34.5, 36.5], waistRange: [30, 32] },
        { sizeUS: 'M', sizeEU: 'L', heightRange: [67, 69], bustRange: [36.5, 38.5], waistRange: [32, 34] },
        { sizeUS: 'L', sizeEU: 'XL', heightRange: [69, 71], bustRange: [38.5, 40.5], waistRange: [34, 36] },
        { sizeUS: 'XL', sizeEU: 'XXL', heightRange: [71, 73], bustRange: [40.5, 42.5], waistRange: [36, 38] },
        { sizeUS: 'XXL', sizeEU: 'XXXL', heightRange: [73, 75], bustRange: [42.5, 44.5], waistRange: [38, 40] },
        { sizeUS: 'XXXL', sizeEU: '4XL', heightRange: [75, 77], bustRange: [44.5, 46.5], waistRange: [40, 42] }
      ];
    } else {
      sizeData = [
        { sizeUS: 'S', sizeEU: 'M', heightRange: [165, 170], bustRange: [88, 93], waistRange: [77, 82] },
        { sizeUS: 'M', sizeEU: 'L', heightRange: [170, 175], bustRange: [93, 98], waistRange: [82, 87] },
        { sizeUS: 'L', sizeEU: 'XL', heightRange: [175, 180], bustRange: [98, 103], waistRange: [87, 92] },
        { sizeUS: 'XL', sizeEU: 'XXL', heightRange: [180, 185], bustRange: [103, 108], waistRange: [92, 97] },
        { sizeUS: 'XXL', sizeEU: 'XXXL', heightRange: [185, 190], bustRange: [108, 113], waistRange: [97, 102] },
        { sizeUS: 'XXXL', sizeEU: '4XL', heightRange: [190, 195], bustRange: [113, 118], waistRange: [102, 107] }
      ];
    }

    // 根据选择的分类匹配对应的范围
    let bestMatch = null;
    let bestScore = 0;
    const tolerance = currentUnit === 'in' ? 0.5 : 2;

    sizeData.forEach((sizeInfo, index) => {
      let score = 0;
      let range;
      if (category === 'height') {
        range = sizeInfo.heightRange;
      } else if (category === 'bust') {
        range = sizeInfo.bustRange;
      } else if (category === 'waist') {
        range = sizeInfo.waistRange;
      } else {
        return;
      }
      
      const isLastRange = index === sizeData.length - 1; // 是否是最后一个范围
      
      // 检查是否在范围内（最后一个范围使用 <=，其他使用 <）
      if (isLastRange) {
      if (measurement >= range[0] && measurement <= range[1]) {
        score = 10; // 精确匹配
      } else if (measurement >= range[0] - tolerance && measurement <= range[1] + tolerance) {
        score = 5; // 接近范围
      } else {
        // 计算距离
        const mid = (range[0] + range[1]) / 2;
        const dist = Math.abs(measurement - mid);
        score = Math.max(0, 5 - dist);
        }
      } else {
        if (measurement >= range[0] && measurement < range[1]) {
          score = 10; // 精确匹配
        } else if (measurement >= range[0] - tolerance && measurement < range[1] + tolerance) {
          score = 5; // 接近范围
        } else {
          // 计算距离
          const mid = (range[0] + range[1]) / 2;
          const dist = Math.abs(measurement - mid);
          score = Math.max(0, 5 - dist);
        }
      }
      
      if (score > bestScore) {
        bestScore = score;
        bestMatch = sizeInfo;
      }
    });

    // 如果没有找到匹配，使用最接近的范围
    if (!bestMatch) {
      sizeData.forEach(sizeInfo => {
        let range;
        if (category === 'height') {
          range = sizeInfo.heightRange;
        } else if (category === 'bust') {
          range = sizeInfo.bustRange;
        } else if (category === 'waist') {
          range = sizeInfo.waistRange;
        } else {
          return;
        }
        
        const mid = (range[0] + range[1]) / 2;
        const dist = Math.abs(measurement - mid);
        
        if (!bestMatch || dist < bestScore) {
          bestScore = dist;
          bestMatch = sizeInfo;
        }
      });
    }

    if (!bestMatch) {
      alert('Unable to determine size. Please check your measurement.');
      return;
    }

    // 保存US尺码
    this.recommendedSizeUS = bestMatch.sizeUS;
    
    // 根据US/EU显示对应的尺码
    const displaySize = sizeType === 'eu' ? bestMatch.sizeEU : bestMatch.sizeUS;
    
    document.getElementById('recommended-size-men-lounge').textContent = displaySize;
    document.getElementById('size-result-men-lounge').style.display = 'block';
    this.recommendedSize = displaySize;

    // 滚动到结果
    document.getElementById('size-result-men-lounge').scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center' 
    });
  }

  calculateTruckSizeMen() {
    const input = document.getElementById('measurement-men-truck');
    if (!input) return;
    
    let measurement = parseFloat(input.value);
    
    if (!measurement || isNaN(measurement)) {
      alert('Please enter a measurement');
      return;
    }

    // 获取当前单位、分类和尺码类型
    const currentUnit = this.getCurrentUnit('men-truck');
    const categorySelect = document.getElementById('category-type-men-truck');
    const category = categorySelect ? categorySelect.value : 'height';
    const sizeTypeSelect = document.getElementById('size-type-men-truck');
    const sizeType = sizeTypeSelect ? sizeTypeSelect.value : 'us';
    
    // 获取表格数据（基于当前单位）
    let sizeData;
    if (currentUnit === 'in') {
      sizeData = [
        { sizeUS: 'S', sizeEU: 'M', heightRange: [65, 67], waistRange: [30, 32], hipsRange: [34, 36] },
        { sizeUS: 'M', sizeEU: 'L', heightRange: [67, 69], waistRange: [32, 34], hipsRange: [36, 38] },
        { sizeUS: 'L', sizeEU: 'XL', heightRange: [69, 71], waistRange: [34, 36], hipsRange: [38, 40] },
        { sizeUS: 'XL', sizeEU: 'XXL', heightRange: [71, 73], waistRange: [36, 38], hipsRange: [40, 42] },
        { sizeUS: 'XXL', sizeEU: 'XXXL', heightRange: [73, 75], waistRange: [38, 40], hipsRange: [42, 44] },
        { sizeUS: 'XXXL', sizeEU: '4XL', heightRange: [75, 77], waistRange: [40, 42], hipsRange: [44, 46] }
      ];
    } else {
      sizeData = [
        { sizeUS: 'S', sizeEU: 'M', heightRange: [165, 170], waistRange: [77, 82], hipsRange: [87, 92] },
        { sizeUS: 'M', sizeEU: 'L', heightRange: [170, 175], waistRange: [82, 87], hipsRange: [92, 97] },
        { sizeUS: 'L', sizeEU: 'XL', heightRange: [175, 180], waistRange: [87, 92], hipsRange: [97, 102] },
        { sizeUS: 'XL', sizeEU: 'XXL', heightRange: [180, 185], waistRange: [92, 97], hipsRange: [102, 107] },
        { sizeUS: 'XXL', sizeEU: 'XXXL', heightRange: [185, 190], waistRange: [97, 102], hipsRange: [107, 112] },
        { sizeUS: 'XXXL', sizeEU: '4XL', heightRange: [190, 195], waistRange: [102, 107], hipsRange: [112, 117] }
      ];
    }

    // 根据选择的分类匹配对应的范围
    let bestMatch = null;
    let bestScore = 0;
    const tolerance = currentUnit === 'in' ? 0.5 : 2;

    sizeData.forEach((sizeInfo, index) => {
      let score = 0;
      let range;
      if (category === 'height') {
        range = sizeInfo.heightRange;
      } else if (category === 'waist') {
        range = sizeInfo.waistRange;
      } else if (category === 'hips') {
        range = sizeInfo.hipsRange;
      } else {
        return;
      }
      
      const isLastRange = index === sizeData.length - 1; // 是否是最后一个范围
      
      // 检查是否在范围内（最后一个范围使用 <=，其他使用 <）
      if (isLastRange) {
      if (measurement >= range[0] && measurement <= range[1]) {
        score = 10; // 精确匹配
      } else if (measurement >= range[0] - tolerance && measurement <= range[1] + tolerance) {
        score = 5; // 接近范围
      } else {
        // 计算距离
        const mid = (range[0] + range[1]) / 2;
        const dist = Math.abs(measurement - mid);
        score = Math.max(0, 5 - dist);
        }
      } else {
        if (measurement >= range[0] && measurement < range[1]) {
          score = 10; // 精确匹配
        } else if (measurement >= range[0] - tolerance && measurement < range[1] + tolerance) {
          score = 5; // 接近范围
        } else {
          // 计算距离
          const mid = (range[0] + range[1]) / 2;
          const dist = Math.abs(measurement - mid);
          score = Math.max(0, 5 - dist);
        }
      }
      
      if (score > bestScore) {
        bestScore = score;
        bestMatch = sizeInfo;
      }
    });

    // 如果没有找到匹配，使用最接近的范围
    if (!bestMatch) {
      sizeData.forEach(sizeInfo => {
        let range;
        if (category === 'height') {
          range = sizeInfo.heightRange;
        } else if (category === 'waist') {
          range = sizeInfo.waistRange;
        } else if (category === 'hips') {
          range = sizeInfo.hipsRange;
        } else {
          return;
        }
        
        const mid = (range[0] + range[1]) / 2;
        const dist = Math.abs(measurement - mid);
        
        if (!bestMatch || dist < bestScore) {
          bestScore = dist;
          bestMatch = sizeInfo;
        }
      });
    }

    if (!bestMatch) {
      alert('Unable to determine size. Please check your measurement.');
      return;
    }

    // 保存US尺码
    this.recommendedSizeUS = bestMatch.sizeUS;
    
    // 根据US/EU显示对应的尺码
    const displaySize = sizeType === 'eu' ? bestMatch.sizeEU : bestMatch.sizeUS;
    
    document.getElementById('recommended-size-men-truck').textContent = displaySize;
    document.getElementById('size-result-men-truck').style.display = 'block';
    this.recommendedSize = displaySize;

    // 滚动到结果
    document.getElementById('size-result-men-truck').scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center' 
    });
  }
  generateSizeTable() {
    // 生成 Lounge & Layers Size Chart 表格
    const loungeTableBody = this.modal ? 
      this.modal.querySelector('#lounge-size-table-body-men') :
      document.getElementById('lounge-size-table-body-men');
    if (loungeTableBody) {
      this.generateLoungeSizeTable(loungeTableBody);
    }
    
    // 生成 Truck & Boxer Size Chart 表格
    const truckTableBody = this.modal ? 
      this.modal.querySelector('#truck-size-table-body-men') :
      document.getElementById('truck-size-table-body-men');
    if (truckTableBody) {
      this.generateTruckSizeTable(truckTableBody);
    }
  }

  generateLoungeSizeTable(tableBody) {
    if (!tableBody) return;
    
    // 获取当前单位（Lounge & Layers tab 的单位）
    const currentUnit = this.getCurrentUnit('men-lounge');
    
    // 根据单位选择不同的数据
    let sizeData;
    if (currentUnit === 'in') {
      // INCH 单位的数据
      sizeData = [
        { sizeUS: 'S', sizeEU: 'M', heightRange: '65-67', bustRange: '34.5-36.5', waistRange: '30-32', hipsRange: '34-36' },
        { sizeUS: 'M', sizeEU: 'L', heightRange: '67-69', bustRange: '36.5-38.5', waistRange: '32-34', hipsRange: '36-38' },
        { sizeUS: 'L', sizeEU: 'XL', heightRange: '69-71', bustRange: '38.5-40.5', waistRange: '34-36', hipsRange: '38-40' },
        { sizeUS: 'XL', sizeEU: 'XXL', heightRange: '71-73', bustRange: '40.5-42.5', waistRange: '36-38', hipsRange: '40-42' },
        { sizeUS: 'XXL', sizeEU: 'XXXL', heightRange: '73-75', bustRange: '42.5-44.5', waistRange: '38-40', hipsRange: '42-44' },
        { sizeUS: 'XXXL', sizeEU: '4XL', heightRange: '75-77', bustRange: '44.5-46.5', waistRange: '40-42', hipsRange: '44-46' }
      ];
    } else {
      // CM 单位的数据（默认）
      sizeData = [
        { sizeUS: 'S', sizeEU: 'M', heightRange: '165-170', bustRange: '88-93', waistRange: '77-82', hipsRange: '87-92' },
        { sizeUS: 'M', sizeEU: 'L', heightRange: '170-175', bustRange: '93-98', waistRange: '82-87', hipsRange: '92-97' },
        { sizeUS: 'L', sizeEU: 'XL', heightRange: '175-180', bustRange: '98-103', waistRange: '87-92', hipsRange: '97-102' },
        { sizeUS: 'XL', sizeEU: 'XXL', heightRange: '180-185', bustRange: '103-108', waistRange: '92-97', hipsRange: '102-107' },
        { sizeUS: 'XXL', sizeEU: 'XXXL', heightRange: '185-190', bustRange: '108-113', waistRange: '97-102', hipsRange: '107-112' },
        { sizeUS: 'XXXL', sizeEU: '4XL', heightRange: '190-195', bustRange: '113-118', waistRange: '102-107', hipsRange: '112-117' }
      ];
    }

    // 清空现有内容
    tableBody.innerHTML = '';

    sizeData.forEach(({ sizeUS, sizeEU, heightRange, bustRange, waistRange, hipsRange }) => {
      const row = document.createElement('tr');
      
      // US/UK SIZE
      const sizeUSCell = document.createElement('td');
      sizeUSCell.textContent = sizeUS;
      row.appendChild(sizeUSCell);
      
      // EU SIZE
      const sizeEUCell = document.createElement('td');
      sizeEUCell.textContent = sizeEU;
      row.appendChild(sizeEUCell);
      
      // Height 范围
      const heightCell = document.createElement('td');
      heightCell.textContent = heightRange;
      row.appendChild(heightCell);
      
      // BUST 范围
      const bustCell = document.createElement('td');
      bustCell.textContent = bustRange;
      row.appendChild(bustCell);
      
      // Waist 范围
      const waistCell = document.createElement('td');
      waistCell.textContent = waistRange;
      row.appendChild(waistCell);
      
      // Hips 范围
      const hipsCell = document.createElement('td');
      hipsCell.textContent = hipsRange;
      row.appendChild(hipsCell);

      tableBody.appendChild(row);
    });

    // 更新表头
    this.updateLoungeSizeTableHeader(currentUnit);
  }

  updateLoungeSizeTableHeader(unit) {
    const heightHeader = document.getElementById('lounge-height-header-men');
    const bustHeader = document.getElementById('lounge-bust-header-men');
    const waistHeader = document.getElementById('lounge-waist-header-men');
    const hipsHeader = document.getElementById('lounge-hips-header-men');
    
    if (!heightHeader || !bustHeader || !waistHeader || !hipsHeader) return;

    if (unit === 'in') {
      // INCH 单位
      heightHeader.textContent = 'Height (INCH)';
      bustHeader.textContent = 'Bust (INCH)';
      waistHeader.textContent = 'Waist (INCH)';
      hipsHeader.textContent = 'Hips (INCH)';
    } else {
      // CM 单位
      heightHeader.textContent = 'Height (CM)';
      bustHeader.textContent = 'Bust (CM)';
      waistHeader.textContent = 'Waist (CM)';
      hipsHeader.textContent = 'Hips (CM)';
    }
  }

  generateTruckSizeTable(tableBody) {
    if (!tableBody) return;
    
    // 获取当前单位（Truck & Boxer tab 的单位）
    const currentUnit = this.getCurrentUnit('men-truck');
    
    // 根据单位选择不同的数据（与Lounge & Layers相同）
    let sizeData;
    if (currentUnit === 'in') {
      // INCH 单位的数据
      sizeData = [
        { sizeUS: 'S', sizeEU: 'M', heightRange: '65-67', waistRange: '30-32', hipsRange: '34-36' },
        { sizeUS: 'M', sizeEU: 'L', heightRange: '67-69', waistRange: '32-34', hipsRange: '36-38' },
        { sizeUS: 'L', sizeEU: 'XL', heightRange: '69-71', waistRange: '34-36', hipsRange: '38-40' },
        { sizeUS: 'XL', sizeEU: 'XXL', heightRange: '71-73', waistRange: '36-38', hipsRange: '40-42' },
        { sizeUS: 'XXL', sizeEU: 'XXXL', heightRange: '73-75', waistRange: '38-40', hipsRange: '42-44' },
        { sizeUS: 'XXXL', sizeEU: '4XL', heightRange: '75-77', waistRange: '40-42', hipsRange: '44-46' }
      ];
    } else {
      // CM 单位的数据（默认）
      sizeData = [
        { sizeUS: 'S', sizeEU: 'M', heightRange: '165-170', waistRange: '77-82', hipsRange: '87-92' },
        { sizeUS: 'M', sizeEU: 'L', heightRange: '170-175', waistRange: '82-87', hipsRange: '92-97' },
        { sizeUS: 'L', sizeEU: 'XL', heightRange: '175-180', waistRange: '87-92', hipsRange: '97-102' },
        { sizeUS: 'XL', sizeEU: 'XXL', heightRange: '180-185', waistRange: '92-97', hipsRange: '102-107' },
        { sizeUS: 'XXL', sizeEU: 'XXXL', heightRange: '185-190', waistRange: '97-102', hipsRange: '107-112' },
        { sizeUS: 'XXXL', sizeEU: '4XL', heightRange: '190-195', waistRange: '102-107', hipsRange: '112-117' }
      ];
    }

    // 清空现有内容
    tableBody.innerHTML = '';

    sizeData.forEach(({ sizeUS, sizeEU, heightRange, waistRange, hipsRange }) => {
      const row = document.createElement('tr');
      
      // US/UK SIZE
      const sizeUSCell = document.createElement('td');
      sizeUSCell.textContent = sizeUS;
      row.appendChild(sizeUSCell);
      
      // EU SIZE
      const sizeEUCell = document.createElement('td');
      sizeEUCell.textContent = sizeEU;
      row.appendChild(sizeEUCell);
      
      // Height 范围
      const heightCell = document.createElement('td');
      heightCell.textContent = heightRange;
      row.appendChild(heightCell);
      
      // Waist 范围
      const waistCell = document.createElement('td');
      waistCell.textContent = waistRange;
      row.appendChild(waistCell);
      
      // Hips 范围
      const hipsCell = document.createElement('td');
      hipsCell.textContent = hipsRange;
      row.appendChild(hipsCell);

      tableBody.appendChild(row);
    });

    // 更新表头
    this.updateTruckSizeTableHeader(currentUnit);
  }

  updateTruckSizeTableHeader(unit) {
    const heightHeader = document.getElementById('truck-height-header-men');
    const waistHeader = document.getElementById('truck-waist-header-men');
    const hipsHeader = document.getElementById('truck-hips-header-men');
    
    if (!heightHeader || !waistHeader || !hipsHeader) return;

    if (unit === 'in') {
      // INCH 单位
      heightHeader.textContent = 'Height (INCH)';
      waistHeader.textContent = 'Waist (INCH)';
      hipsHeader.textContent = 'Hips (INCH)';
    } else {
      // CM 单位
      heightHeader.textContent = 'Height (CM)';
      waistHeader.textContent = 'Waist (CM)';
      hipsHeader.textContent = 'Hips (CM)';
    }
  }

  updateLoungeInputPlaceholder() {
    const categorySelect = document.getElementById('category-type-men-lounge');
    const input = document.getElementById('measurement-men-lounge');
    const currentUnit = this.getCurrentUnit('men-lounge');
    
    if (!categorySelect || !input) return;
    
    const category = categorySelect.value;
    const unitText = currentUnit === 'cm' ? 'cm' : 'inches';
    
    let placeholderText;
    if (category === 'height') {
      placeholderText = `Height measurement (${unitText})`;
    } else if (category === 'bust') {
      placeholderText = `BUST measurement (${unitText})`;
    } else if (category === 'waist') {
      placeholderText = `Waist measurement (${unitText})`;
    }
    
    if (placeholderText) {
      input.placeholder = placeholderText;
    }
  }

  updateTruckInputPlaceholder() {
    const categorySelect = document.getElementById('category-type-men-truck');
    const input = document.getElementById('measurement-men-truck');
    const currentUnit = this.getCurrentUnit('men-truck');
    
    if (!categorySelect || !input) return;
    
    const category = categorySelect.value;
    const unitText = currentUnit === 'cm' ? 'cm' : 'inches';
    
    let placeholderText;
    if (category === 'height') {
      placeholderText = `Height measurement (${unitText})`;
    } else if (category === 'waist') {
      placeholderText = `Waist measurement (${unitText})`;
    } else if (category === 'hips') {
      placeholderText = `Hips measurement (${unitText})`;
    }
    
    if (placeholderText) {
      input.placeholder = placeholderText;
    }
  }

  // 获取当前单位
  getCurrentUnit(type) {
    const activeBtn = document.querySelector(`[data-type="${type}"].bra-size-calculator__unit-btn.active`);
    return activeBtn ? activeBtn.dataset.unit : 'in';
  }

  // 处理单位切换
  handleUnitToggle(unit, type) {
    // 更新按钮状态
    const unitBtns = document.querySelectorAll(`[data-type="${type}"].bra-size-calculator__unit-btn`);
    unitBtns.forEach(btn => {
      btn.classList.remove('active');
      if (btn.dataset.unit === unit) {
        btn.classList.add('active');
      }
    });

    // 更新标签
    const unitLabels = document.querySelectorAll(`.unit-label-${type}`);
    const unitText = unit === 'cm' ? 'cm' : 'inches';
    unitLabels.forEach(label => {
      label.textContent = unitText;
    });

    // 转换输入框的值
    if (type === 'men-lounge') {
      this.convertInputValues('measurement-men-lounge', unit);
      this.updateLoungeInputPlaceholder();
    } else if (type === 'men-truck') {
      this.convertInputValues('measurement-men-truck', unit);
      this.updateTruckInputPlaceholder();
    }

    // 更新输入框的 data-unit 属性
    const inputs = document.querySelectorAll(`input[data-unit]`);
    inputs.forEach(input => {
      if (input.id.includes(type) && (input.dataset.unit === 'in' || input.dataset.unit === 'cm')) {
        input.dataset.unit = unit;
      }
    });
  }

  // 转换输入框值
  convertInputValues(inputId, targetUnit) {
    const input = document.getElementById(inputId);
    if (!input || !input.value) return;

    const currentValue = parseFloat(input.value);
    if (isNaN(currentValue)) return;

    const currentUnit = input.dataset.unit || 'in';
    
    if (currentUnit === targetUnit) return;

    let convertedValue;
    if (currentUnit === 'in' && targetUnit === 'cm') {
      convertedValue = currentValue * 2.54;
    } else if (currentUnit === 'cm' && targetUnit === 'in') {
      convertedValue = currentValue / 2.54;
    } else {
      return;
    }

    input.value = convertedValue.toFixed(1);
    input.dataset.unit = targetUnit;
  }
}

// 初始化男士尺码计算器
document.addEventListener('DOMContentLoaded', () => {
  const menModal = document.getElementById('bra-size-calculator-men');
  if (menModal) {
    window.braSizeCalculatorMen = new MenSizeCalculator();
    window.braSizeCalculatorMen.modal = menModal;
    window.braSizeCalculatorMen.type = 'men';
    window.braSizeCalculatorMen.init();
  }
});
